<template>
	<div class="parent outline">

		<div style="display:inline-block; ">
			<p style="font-size:32px; font-weight:bold; margin:0px; width:49%; float:left;">{{qbFile}}</p>
			<p style="font-size:32px; font-weight:bold; margin:0px; width:49%; text-align: right; float:right;">Invoice</p>
		</div>

		<table class="hidetable" style="border:none">
			<tr>
				<td>Bill To</td>
				<td style="width:25%">
					<table>
						<tr>
							<td><b>Date</b></td>
							<td><b>Invoice #</b></td>
						</tr>
						<tr>
							<td>{{getDate()}}</td>
							<td></td>
						</tr>
					</table>
				</td>
			</tr>
			<tr v-for="(address,index) in addresses">
				<td style="padding:0px; height:25px;">
					<p style="margin:0px;">{{address}}</p>
				</td>
			</tr>
		</table>
		<table style="width:50%; margin-right:0px; margin-left:auto;">
			<tr>
				<td><b>P.O. No.</b></td>
				<td><b>Project</b></td>
			</tr>
			<tr>
				<td>{{ponumber}}</td>
				<td><p>{{column_data[0]}}</p></td>
			</tr>
		</table>
		<table>
			<tr>
				<td style="width:10%"><p style="text-align: center;">Quantity</p></td>
				<td><p style="text-align: center;">Description</p></td>
				<td style="width:15%"><p style="text-align: center;">Rate</p></td>
				<td style="width:15%"><p style="text-align: center;">Amount</p></td>
			</tr>
			<tr class="hideborder">
				<td></td>
				<td><p style="white-space: pre-wrap;">{{column_data[4]}}</p></td>
				<td></td>
				<td></td>
			</tr>
			<tr v-if="overlap==true" class="hideborder">
				<td colspan=4 style="padding:0px; height:0px;"><div class="overlap">Multiple times and minimum time applied detected, check for overlaps</div></td>
			</tr>
			<tr class="hideborder" v-for="(time,index) in times" v-if="time[6]!=null">
				<td style="height:25px;"><p v-for="(val,i) in time[6]" v-if="time[6][i]!=0" style="text-align:right;">
					{{val}}
				</p></td>
				<td style="height:25px;"><p v-for="(val,i) in time[5].split('\n')" v-if="time[6][i]!=0">
					{{val}}
				</p></td>
				<td style="height:25px;"><p v-for="(val,i) in time[8]" v-if="time[6][i]!=0">
					{{val}}
				</p></td>
				<td style="height:25px;"><p v-for="(val,i) in time[9]" v-if="time[6][i]!=0">
					{{val}}
				</p></td>
			</tr>
			<tr class="hideborder" v-for="(material,index) in materials">
				<td style="height:25px;"><p v-if="material[3]!=null" style="text-align:right;">{{material[3]}}</p></td>
				<td style="height:25px;"><p v-if="material[2]!=null">{{material[2]}}</p></td>
				<td style="height:25px;"><p v-if="material[4]!=null">{{material[4]}}</p></td>
				<td style="height:25px;"><p v-if="material[5]!=null">{{material[5]}}</p></td>
			</tr>
			<tr>
				<td colspan=2>
					<p v-if="showMiscText==true">Thank you for your business.</p>
				</td>
				<td colspan=2>
					<b style="float:left; font-size:32px;">Total</b><p style="float:right">USD {{totalUSD}}</p>
				</td>
			</tr>
			<tr>
				<td colspan=4 style="text-align:center;">
					<p v-if="showMiscText==true">Terms of payment is Net 15 days, 2.5% compounded monthly interest on all late payments. Our Terms of Use located at www.LDpowerautomation.com/TermsofUse.pdf apply.</p>
				</td>
			</tr>
			<tr>
				<td colspan=4 style="text-align:center;">
					<p v-if="showMiscText==true">For questions, you can contact us at: tel +1 310 7071115, fax +1 310 6269486, e-mail accounting@ldpa.us</p>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		column_data:Array,
		minTimeActive:Boolean,
		times:Array,
		materials:Array,
		ponumber:String,
		idAddrs: Number,
		idHourCalc: Number,
		idMaterialRate: Number,
		term: String,
		showMiscText:Boolean,
    },
	data() {
		return {
			addresses:[],
			qbFile:'',

			totalUSD:0,
			overlap:false,
		}
	},
	async created (){
		this.search(this.idAddrs, [this.term]).then((res) => {
			if(res.data.data!=null && res.data.data.column_data!=null){
				this.addresses = res.data.data.column_data[0].splice(1);
				this.qbFile = res.data.data.column_data[0][0];
			}
		})
	},
	methods:{
		search(id, sendData){
			return(api.postData(
				{
					type:"search",
					data:{
						pageid:id,
						data:sendData,
					}
				}
			))
		},
		getDate(){
			var date = new Date()
			return (date.getMonth() + 1)+"/"+date.getDate()+"/"+date.getFullYear();
		},
		getCalculatedTimes(timesID){
			this.search(this.idHourCalc, [this.times[timesID][1],this.times[timesID][2],this.times[timesID][3],this.term,this.column_data[10]]).then((res) => {
				this.times[timesID][6] = res.data.hourData.data.column_data[0]
				this.times[timesID][8] = res.data.rateData.data.column_data[0]
				this.times[timesID][9] = []

				var total = 0.0;
				for(var i = 0;i<this.times[timesID][6].length;i++){
					total+=parseFloat(this.times[timesID][6][i]);
					this.times[timesID][6][i] = (this.times[timesID][6][i] * this.times[timesID][4]).toFixed(2);
					this.times[timesID][9][i] = (this.times[timesID][6][i] * this.times[timesID][8][i]).toFixed(2);
				}
				this.times[timesID][7]=total.toFixed(2);

				if(timesID>=this.times.length-1){
					this.getTotalUSD();
					this.getOverlap();
				}
			})
		},
		getMaterialRates(materialsID){
			/*this.search(this.idMaterialRate, [this.materials[materialsID][1]]).then((res) => {
				this.materials[materialsID][4] = parseFloat(res.data.data.column_data[0][0]).toFixed(2);
				this.materials[materialsID][5] = (this.materials[materialsID][4] * this.materials[materialsID][3]).toFixed(2);

				if(materialsID>=this.materials.length-1){
					this.getTotalUSD();
				}
			})*/

			this.materials[materialsID][5] = (this.materials[materialsID][4] * this.materials[materialsID][3]).toFixed(2);

			if(materialsID>=this.materials.length-1){
				this.getTotalUSD();
			}
		},
		updateTimes(){
			for(var i = 0;i<this.times.length;i++){
				if(this.times[i][1]!=null && this.times[i][2]!=null){
					this.getCalculatedTimes(i);
				}
			}
		},
		getTotalUSD(){
			var total = 0;
			if(this.times!=null){
				for(var i = 0;i<this.times.length;i++){
					if(this.times[i][9]!=null){
						for(var j = 0;j<this.times[i][9].length;j++){
							total+=parseFloat(this.times[i][9][j])
						}
					}
				}
			}
			if(this.materials!=null){
				for(var i = 0;i<this.materials.length;i++){
					if(this.materials[i][5]!=null){
						total+=parseFloat(this.materials[i][5])
					}
				}
			}
			this.totalUSD=total.toFixed(2);
		},
		getOverlap(){
			var isOverlap=false;

			if(this.times.length>=2){

				for(var i = 0;i<this.times.length;i++){
					var startDate = new Date(this.times[i][1]);
					var endDate = new Date(this.times[i][2]);
					var diffTime = Math.abs(startDate - endDate);
					var diffHours = (diffTime / (1000 * 60 * 60));
					if(diffHours< this.times[i][6].reduce((a, b) => parseInt(a) + parseInt(b), 0) ){
						isOverlap=true;
						break;
					}
				}
			}

			this.overlap = isOverlap;
		}
	},
	watch:{
		times(){
			this.updateTimes();
		},
		minTimeActive(){
			this.updateTimes();
		},
		materials(){
			for(var i = 0;i<this.materials.length;i++){
				if(this.materials[i][1]!=null){
				this.getMaterialRates(i);
				}
			}
		}
	},
}
</script>

<style scoped>
.outline {
	border: 2px solid black;
	padding:5px;
}

.hidetable > tr > td {
	border: none;
	table-layout:fixed;
	background-color: #ffffff;
	border-collapse: collapse;
	empty-cells: show;
}

.hideborder > td {
	 border-top: none;
	 border-bottom: none;
}

p{
	padding:0px;
	margin:0px;
}

.overlap {
	padding:0px 5px 0px 5px;
	font-size:15px;
	font-weight: bold;
	color:#000000;
	background-color:#ffcfcf;
	border-radius: 5px;
	border:2px solid #d62929;
	margin:0px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/layout_10.vue